import React, { useEffect, useContext } from "react";
import Page from "./Page";
import MaterialTable from "material-table";

import WarningInfo from "./notification/WarningInfo";
import AppContext from "./context/AppContext";
import ActionContext from "./context/ActionContext";
import {
	FETCH_SKILLS,
	UPDATE_SKILL,
	CREATE_SKILL,
	DELETE_SKILL
} from "./context/types";

export default function SkillsPage(props) {
	const { skills, loading, updating } = useContext(AppContext);
	const dispatch = useContext(ActionContext);
	useEffect(() => {
		document.title = "Available Skills";
		dispatch({ type: FETCH_SKILLS });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<Page header="Skills" location={props.location.pathname}>
			{!loading && (
				<MaterialTable
					title="Available Skills"
					columns={[
						{
							title: "Name*",
							field: "name"
						},
						{
							title: "Approved*",
							field: "approved",
							type: "boolean"
						}
					]}
					data={skills}
					components={{
						Toolbar: props => {
							return (
								<WarningInfo
									toolbar={props}
									message="Be careful deleting rows as it may affect users information"
								/>
							);
						}
					}}
					editable={{
						onRowAdd: newData =>
							new Promise((resolve, reject) => {
								dispatch({
									type: CREATE_SKILL,
									payload: newData
								});
								if (!updating) {
									resolve();
								}
							}),
						onRowUpdate: (newData, oldData) =>
							new Promise((resolve, reject) => {
								dispatch({
									type: UPDATE_SKILL,
									payload: {
										name: oldData.name,
										data: newData
									}
								});
								if (!updating) {
									resolve();
								}
							}),
						onRowDelete: oldData =>
							new Promise((resolve, reject) => {
								dispatch({
									type: DELETE_SKILL,
									payload: oldData
								});
								if (!updating) {
									resolve();
								}
							})
					}}
					options={{
						actionsColumnIndex: -1
					}}
				/>
			)}
		</Page>
	);
}
